export default "__VITE_ASSET__C$BFjJdH__"